import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getManifestacoesGeojsonRequest } from "store/modules/ouvidoria/manifestacoes/actions/getManifestacoesGeojson";
import { useTypedSelector } from "store/hooks";
import { Alert, Box, Skeleton, VStack, Text } from "@chakra-ui/react";
import { TextGray } from "components/Atomos/Texts/TextGray";

export function TabManifestacoes() {
  const dispatch = useDispatch();

  const { isRequesting: loadingManifestacoes, successPayload: manifestacoes } =
    useTypedSelector(
      (state) => state.ouvidoria.manifestacoes.getManifestacoesGeojson
    );

  useEffect(() => {
    dispatch(getManifestacoesGeojsonRequest());
  }, []);

  return (
    <Box>
      {!loadingManifestacoes && manifestacoes?.features.length === 0 && (
        <Alert status="info" fontSize="sm" mt="2">
          Nenhuma manifestação encontrada.
        </Alert>
      )}
      {loadingManifestacoes ? (
        <VStack pt="4" spacing={8}>
          {Array(4)
            .fill(0)
            .map((_, i) => (
              <VStack key={i} w="full">
                <Skeleton height="20px" w="full" />
                <Skeleton height="40px" w="full" />
              </VStack>
            ))}
        </VStack>
      ) : (
        <Box>
          {manifestacoes?.features?.map((feature) => {
            const prop = feature.properties;
            return (
              <Box
                key={feature.properties.id}
                w="full"
                borderBottom="thin"
                borderBottomStyle="solid"
                borderBottomColor={"gray.100"}
              >
                <VStack
                  p={2}
                  spacing={0}
                  justify="flex-start"
                  align="flex-start"
                >
                  <Text fontSize="md" fontWeight="medium">
                    {prop.titulo}
                  </Text>
                  <TextGray fontSize="sm">{prop.name}</TextGray>
                </VStack>
              </Box>
            );
          })}
        </Box>
      )}
    </Box>
  );
}
